import React from "react";
import { MsalProvider } from "@azure/msal-react";
import { IPublicClientApplication } from "@azure/msal-browser";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { IonApp } from "@ionic/react";
import { PageLayout } from "./pages/layout";
import Dashboard from "./pages/Dashboard";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 1000 * 60 * 5,
			refetchOnWindowFocus: false,
		},
	},
});

const App: React.FC<{ msalInstance: IPublicClientApplication }> = ({ msalInstance }) => {
	return (
		<React.StrictMode>
			<QueryClientProvider client={queryClient}>
				<MsalProvider instance={msalInstance}>
					<IonApp>
						<BrowserRouter>
							<Routes>
								<Route path="/" element={<PageLayout />}>
									<Route index element={<Navigate to="/dashboard" replace />} />
									<Route path="dashboard" element={<Dashboard />} />
									<Route path="notices" element={<Dashboard />} />
									<Route path="calendar" element={<Dashboard />} />
									<Route path="groups" element={<Dashboard />} />
								</Route>
							</Routes>
						</BrowserRouter>
					</IonApp>
				</MsalProvider>
			</QueryClientProvider>
		</React.StrictMode>
	);
};

export default App;
